import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import { apiHolder as api, getIn18Text } from 'api';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { ScheduleDatePicker, ScheduleTimeStepPicker } from '@web-schedule/components/FormComponents';
import TimeZoneSelect from './TimeZoneSelect';
import style from './index.module.scss';
const systemApi = api.api.getSystemApi();
const ScheduledSent = (props) => {
    const [timeZoneList, setTimeZoneList] = useState([]);
    const [sysTimeZone, setSysTimeZone] = useState();
    const dispatch = useAppDispatch();
    const scheduleDate = useAppSelector(state => state.mailReducer.currentMail.scheduleDate) || undefined;
    const scheduleDateTimeZone = useAppSelector(state => state.mailReducer.currentMail.scheduleDateTimeZone);
    const sysTime = useMemo(() => {
        if (!scheduleDate || typeof scheduleDateTimeZone !== 'number' || !sysTimeZone)
            return '';
        const systemMoment = systemApi.timeZoneTrans(scheduleDate, scheduleDateTimeZone, (sysTimeZone === null || sysTimeZone === void 0 ? void 0 : sysTimeZone.key) || 8);
        if (!systemMoment)
            return '';
        return systemMoment.format('YYYY-MM-DD HH:mm');
    }, [scheduleDate, scheduleDateTimeZone, sysTimeZone]);
    const onScheduleTimeZoneChange = (timeZone) => {
        dispatch(mailActions.doChangeMailScheduleTimeZone(timeZone));
    };
    const onScheduleDateChange = (date) => {
        dispatch(mailActions.doChangeMailSchedule(`${date.format('YYYY-MM-DD')} ${moment(scheduleDate).format('HH:mm:ss')}`));
    };
    const onScheduleTimeChange = (time) => {
        dispatch(mailActions.doChangeMailSchedule(`${moment(scheduleDate).format('YYYY-MM-DD')} ${time.format('HH:mm:ss')}`));
    };
    useEffect(() => {
        const timeZoneList = systemApi.getTimeZoneList();
        setTimeZoneList(timeZoneList.filter(item => item.key !== 999) || []);
    }, []);
    useEffect(() => {
        const curTimeZone = systemApi.getSystemTimeZone();
        setSysTimeZone(curTimeZone);
    }, []);
    return (React.createElement("div", { className: style.scheduleTime },
        React.createElement("span", { className: style.sendTime },
            getIn18Text('FASONGSHIJIAN'),
            ":"),
        React.createElement(TimeZoneSelect, { timeZoneList: timeZoneList, onChange: onScheduleTimeZoneChange, timeZone: scheduleDateTimeZone }),
        React.createElement(ScheduleDatePicker, { allowClear: false, onChange: onScheduleDateChange, value: moment(scheduleDate), className: style.timeInput, style: {
                marginRight: '8px',
                width: '110px',
                borderRadius: '4px',
            } }),
        React.createElement(ScheduleTimeStepPicker, { onChange: onScheduleTimeChange, value: moment(scheduleDate), timeIntervals: 15, className: style.timeInput, style: {
                marginRight: '8px',
                width: '56px',
                borderRadius: '4px',
                padding: '4px',
                textAlign: 'center',
            } }),
        React.createElement("span", { className: style.willSend },
            getIn18Text('YOUJIANJIANGYU'),
            sysTimeZone ? sysTimeZone.value : '',
            " ",
            sysTime,
            getIn18Text('FACHU'))));
};
export default ScheduledSent;
